import {
    IconArrowsDiagonal,
    IconArrowsDiagonalMinimize2,
    IconDotsVertical,
} from '@tabler/icons-react';
import classNames from 'classnames';
import { SyntheticEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/Button';
import { theme as dropdownTheme } from 'shared/Dropdown/Dropdown';
import { useSiteSelectorContext } from '../SiteSelectorContext';
import { GROUP_EXPANDED_STATE_OPTIONS } from '../constants';
import { GroupExpandedState } from '../types';
import { PopoverForm } from './PopoverForm';

export const SettingsPopover = () => {
    const { t } = useTranslation('navigation', {
        keyPrefix: 'site_selector.controls',
    });

    const { groupBy, setGroupExpandedState } = useSiteSelectorContext();

    const onClose = useCallback(() => {}, []);

    const onSubmit = useCallback(
        (event: SyntheticEvent<HTMLFormElement, SubmitEvent>) => {
            event.preventDefault();

            const groupExpandedState =
                event.nativeEvent.submitter?.getAttribute('value');

            setGroupExpandedState(groupExpandedState as GroupExpandedState);
        },
        [setGroupExpandedState]
    );

    return (
        <div
            className={classNames(
                'ml-auto',
                '[&_>_*_>_button]:border-none',
                '[&_>_*_>_button]:rounded-sm',
                '[&_>_*_>_button]:text-secondary',
                '[&_>_*_>_button:hover]:text-primary',
                '[&_>_*_>_button:focus-visible]:text-primary',
                '[&_>_*_>_button[aria-expanded="true"]]:text-primary',
                '[&_>_*_>_button_>_span]:p-1'
            )}
        >
            <PopoverForm
                dirty={false}
                icon={IconDotsVertical}
                label={t('settings.label')}
                onClose={onClose}
                onSubmit={onSubmit}
            >
                <div className="flex flex-col -mx-3 -my-1">
                    {GROUP_EXPANDED_STATE_OPTIONS.map(
                        (groupExpandedStateOption) => (
                            <Button
                                key={groupExpandedStateOption}
                                className={classNames(
                                    dropdownTheme.floating?.item?.base,
                                    'rounded-none'
                                )}
                                color="unstyled"
                                disabled={groupBy === 'ungrouped'}
                                type="submit"
                                value={groupExpandedStateOption}
                            >
                                {groupExpandedStateOption === 'collapsed' ? (
                                    <IconArrowsDiagonalMinimize2 />
                                ) : (
                                    <IconArrowsDiagonal />
                                )}
                                {t(
                                    `settings.group_expanded_state.option.${groupExpandedStateOption}`
                                )}
                            </Button>
                        )
                    )}
                </div>
            </PopoverForm>
        </div>
    );
};
